<template>
  <modal-window :loading="loading" v-on:close="$emit('closeGroupVersionEditor')">
    <template slot="header">
      <p class="modal-card-title">{{ header }}</p>
      <button class="delete" v-on:click="$emit('closeGroupVersionEditor')" aria-label="close"></button>
    </template>
    <template slot="body">
      <!-- <label class="label">Initial version</label> -->
      <div class="field is-grouped tooltip is-tooltip-bottom" data-tooltip="Version of the product">
        <p class="control">
          <label class="label">Major</label>
          <input v-bind:class="{ 'is-danger':  (newVersionMajor < 0 || !isInteger(newVersionMajor)) && saveClicked}"
                 class="input" type="number" min="0" step="1" pattern="\d*" v-model.number.trim="newVersionMajor">
        </p>
        <p class="control">
          <label class="label">Minor</label>
          <input v-bind:class="{ 'is-danger':  (newVersionMinor < 0 || !isInteger(newVersionMinor)) && saveClicked}"
                 class="input" type="number" min="0" step="1" pattern="\d*" v-model.number.trim="newVersionMinor">
        </p>
        <p class="control">
          <label class="label">Build</label>
          <input v-bind:class="{ 'is-danger':  (newVersionBuild < 0 || !isInteger(newVersionBuild)) && saveClicked}"
                 class="input" type="number" min="0" step="1" pattern="\d*" v-model.number.trim="newVersionBuild">
        </p>
      </div>
      <p v-if="(newVersionMajor < 0 || newVersionMinor < 0 || newVersionBuild < 0) && saveClicked" class="help is-danger">You should specify not negative product version!</p>
      <p v-if="(!isInteger(newVersionMajor) || !isInteger(newVersionMinor) || !isInteger(newVersionBuild)) && saveClicked" class="help is-danger">
        Product version should be integer and not negative!
      </p>

      <div class="field">
        <label class="label">Name</label>
        <div class="control tooltip" data-tooltip="Name of the product version (not necessary)">
          <input class="input" type="text" v-model.trim="newVersionName" placeholder="Rostov-on-Don">
        </div>
      </div>

      <div class="field">
        <label class="label">Type</label>
        <div class="control">
          <div class="select tooltip is-tooltip-right" data-tooltip="Specifies a type of the version">
            <select v-model="selectedType">
              <option v-for="(type, index) in types" :key="index" v-bind:value="type">
                {{ type}}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">State</label>
        <div class="control">
          <div class="select tooltip is-tooltip-right" data-tooltip="Specifies a stage of building the version">
            <select v-model="selectedState">
              <option v-for="(state, index) in states" :key="index" v-bind:value="state">
                {{ state}}
              </option>
            </select>
          </div>
        </div>
      </div>
      <!-- errors -->
      <br>
      <div class=" has-text-left  has-text-danger" v-if="errors.length">
        <b class="label is-danger">Please fix this error:</b>
        <ul>
          <li class="is-danger" v-for="(error,index) in errors"
              :key="index">{{ error }}</li>
        </ul>
      </div>
      <!-- end errors -->
    </template>
    <template slot="footer">
      <button class="button is-success" v-on:click="submit()" v-on:keyup.enter="submit()">Save</button>
      <button class="button" v-on:click="$emit('closeGroupVersionEditor')">Cancel</button>
    </template>
  </modal-window>
</template>

<script>
  import ModalWindow from "./ModalWindow";
  //import this.HTTP from "./Http";

  export default {
    name: "group-version-editor",
    components: { ModalWindow },
    props: {
      groupId: Number,
      header: String
    },
    data() {
      return {
        newVersionName: "",
        selectedType: "None",
        newVersionMajor: 2025,
        newVersionMinor: 1,
        newVersionBuild: 0,

        states: [],
        types: [],
        selectedState: "Success",

        saveClicked: false,
        recordProcessing: false, //should prevent record duplicate creating
        errors: [],
        loading: false
      };
    },
    methods: {
      createVersion() {
        this.HTTP.post(`productversions/group`, {
          name: this.newVersionName,
          type: this.selectedType,
          state: this.selectedState,
          major: this.newVersionMajor,
          minor: this.newVersionMinor,
          build: this.newVersionBuild,
          productGroupId: this.groupId
        })
          .then(response => {
            this.recordProcessing = false;
            this.$emit("closeGroupVersionEditor");
          })
          .catch(e => {
            this.recordProcessing = false;
            this.errors = e.response.data.description;
            console.log(e.text);
          });
      },
      getStates() {
        this.loading = true;
        this.HTTP.get("productversions/states")
          .then(response => {
            this.states = response.data;

            this.loading = false;
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
          });
      },
      getTypes() {
        this.loading = true;
        this.HTTP.get("productversions/types")
          .then(response => {
            this.types = response.data;

            this.loading = false;
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
          });
      },
      submit() {
        console.log("recordProcessing - " + this.recordProcessing);
        if (!this.recordProcessing) {
          this.saveClicked = true;
          if (
            this.newVersionMajor >= 0 &&
            this.newVersionMinor >= 0 &&
            this.newVersionBuild >= 0 &&
            this.isInteger(this.newVersionMajor) &&
            this.isInteger(this.newVersionMinor) &&
            this.isInteger(this.newVersionBuild)
          ) {
            this.recordProcessing = true;
            this.createVersion();
          }
        }
      },
      isInteger(num) {
        return (num ^ 0) === num;
      }
      // keyDownListener(evt) {
      //   if (evt.keyCode === 27) this.$emit("closeVersionEditor");
      //   else if (evt.keyCode === 13) this.submit();
      // }
    },
    created() {
      this.loading = true;
      document.addEventListener("keydown", this.keyDownListener);
      this.getStates();
      this.getTypes();
    },
    destroyed: function () {
      document.removeEventListener("keydown", this.keyDownListener);
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/GroupVersionCreator.vue